import { Get, Post } from '../helpers';
import { FontPack, CreateFontPack } from '@/types/theme-packs.types';

export const GetFonts = async (channel: number): Promise<FontPack[]> => {
  return Get({ url: `/v3/admin/channel/fonts/${channel}` });
};

export const CreateFont = async (createFontParams: CreateFontPack): Promise<FontPack> => {
  return Post({ url: '/v3/admin/channel/fonts', body: createFontParams });
};
